import { ODataStoreRequestConfiguration } from '@/auth/api/config'
import { useTokenRefresh, AzureUserInfo, getAzureUserInformation } from '@/auth/azure/azureManager'
import DataSource from 'devextreme/data/data_source'
import ODataStore from 'devextreme/data/odata/store'
import {
  Column,
  DataGrid,
  DataGridRef,
  Editing,
  Item,
  Paging,
  RequiredRule,
  StateStoring,
  Toolbar,
} from 'devextreme-react/data-grid'
import type { InitNewRowEvent, SavingEvent } from 'devextreme/ui/data_grid'
import { AutodeskOldRefsGridProps } from '@/routes/clients/client/ClientEditor.types'
import notify from 'devextreme/ui/notify'
import { useScreenSize } from '@/themes/media-query'
import { ClickEvent } from 'devextreme/ui/button'
import { useRef } from 'react'

const OldRefsGrid = (props: AutodeskOldRefsGridProps) => {
  const { azienda, readOnly } = props
  const token = useTokenRefresh()
  const currentScreenSize = useScreenSize()
  const gridRef = useRef<DataGridRef>(null)

  const aziendaOldRefsDataSource = new DataSource({
    store: new ODataStore({
      url: `${import.meta.env.VITE_QSADMINAPI_HOST}/nome_noto`,
      key: 'id',
      version: 4,
      errorHandler: (e) => {
        console.error(e.errorDetails)
        if (!e.errorDetails) return
        notify(
          {
            message: `Errore : ${e.errorDetails?.message}`,
            type: 'error',
            displayTime: 5000,
          },
          {
            position: 'bottom center',
            direction: 'up-push',
          },
        )
      },
      beforeSend: ODataStoreRequestConfiguration(token),
    }),
    filter: [['azienda.id', azienda && 'id' in azienda ? azienda?.id : null]],
    expand: ['azienda'],
  })

  return (
    <>
      <DataGrid
        id={`client-oldrefs-grid`}
        dataSource={aziendaOldRefsDataSource}
        ref={gridRef}
        noDataText="Nessun vecchio riferimento associato al cliente"
        showBorders={true}
        showColumnLines={true}
        focusedRowEnabled={true}
        columnHidingEnabled={currentScreenSize.isSmall || currentScreenSize.isXSmall || currentScreenSize.isMedium}
        allowColumnReordering={true}
        allowColumnResizing={true}
        rowAlternationEnabled={true}
        wordWrapEnabled={false}
        repaintChangesOnly={true}
        width="100%"
        onSaving={(e: SavingEvent) => {
          console.log('SAVINGGG', e)
        }}
        onInitNewRow={(e: InitNewRowEvent) => {
          e.data.azienda = azienda
        }}
      >
        <Paging defaultPageSize={8} />
        <Editing
          mode="batch"
          allowAdding={!readOnly}
          allowDeleting={!readOnly}
          allowUpdating={!readOnly}
          selectTextOnEditStart={true}
          startEditAction={'click'}
        />
        <StateStoring enabled={true} type="localStorage" storageKey={`client-oldrefs-grid`} savingTimeout={50} />
        <Column dataField={'id'} caption={'ID'} visible={false} />,
        <Column dataField={'azienda.nome'} caption={'AZIENDA'} visible={false} editorOptions={{ readOnly: true }} />
        <Column dataField={'nome'} caption={'NOME'} visible={true}>
          <RequiredRule message="Il nome è obbligatorio" />
        </Column>
        <Column dataField={'note'} caption={'NOTE'} visible={true} />
        <Toolbar>
          <Item
            location="before"
            locateInMenu="never"
            showText="inMenu"
            widget="dxButton"
            options={{
              hint: 'Refresh',
              text: 'Refresh',
              icon: 'refresh',
              onClick: (e: ClickEvent) => {
                gridRef.current?.instance().refresh()
              },
              stylingMode: 'text',
            }}
          ></Item>
          <Item
            name="addRowButton"
            options={{
              hint: 'Nuovo vecchio riferimento',
              text: 'Nuovo vecchio riferimento',
              stylingMode: 'text',
            }}
          ></Item>
          <Item
            name="saveButton"
            options={{
              hint: 'Salva',
              text: 'Salva',
              stylingMode: 'text',
            }}
          ></Item>
          <Item
            name="revertButton"
            options={{
              hint: 'Annulla modifiche',
              text: 'Annulla modifiche',
              stylingMode: 'text',
            }}
          ></Item>
        </Toolbar>
      </DataGrid>
    </>
  )
}

export default OldRefsGrid
